module.exports = __webpack_public_path__ + "static/media/whitelogo.5860f304.png";